import { ChatSessionType } from '@demind-inc/core';
import { AssistantChatMessage, AssistantPlanEntryButton } from '../types';

export const assistantPlanEntryButtons: AssistantPlanEntryButton[] = [
  { id: 'scheduler', text: '📅 Plan my entire day' },
  { id: 'task', text: '✅ Find the best time for my tasks' },
  { id: 'freeText', text: '💪 Plan my workout today' },
  { id: 'recommendation', text: '🔍 What should I do right now?' },
];

export const getAssistantExplanationQuestion = (sessionType: ChatSessionType) =>
  `What would you like to know more about your ${sessionType}?`;

export const ASSISTANT_PLAN_CHAT_START_MESSAGE: AssistantChatMessage = {
  messageId: 'plan_1',
  start: true,
  role: 'assistant',
  sentAt: new Date().toISOString(),
  title: 'How can I help you today?',
  content: '',
  ctaButtons: assistantPlanEntryButtons,
};

export const ASSISTANT_EXPLA_CHAT_START_MESSAGE = (
  sessionType: ChatSessionType
): AssistantChatMessage => {
  return {
    messageId: 'expla_1',
    start: false,
    role: 'assistant',
    sentAt: new Date().toISOString(),
    title: getAssistantExplanationQuestion(sessionType),
    content: '',
  };
};
